import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/laugh-squint': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M248 8c137 0 248 111 248 248s-111 248-248 248-248-111-248-248 111-248 248-248zM389.4 397.4c37.8-37.8 58.6-88 58.6-141.4s-20.8-103.6-58.6-141.4c-37.8-37.8-88-58.6-141.4-58.6s-103.6 20.8-141.4 58.6c-37.8 37.8-58.6 88-58.6 141.4s20.8 103.6 58.6 141.4c37.8 37.8 88 58.6 141.4 58.6s103.6-20.8 141.4-58.6zM343.6 196l33.6 40.3c8.6 10.4-3.9 24.8-15.4 18l-80-48c-7.8-4.7-7.8-15.9 0-20.6l80-48c11.6-6.8 24 7.7 15.4 18zM134.2 254.3c-11.6 6.8-24.1-7.6-15.4-18l33.6-40.3-33.6-40.3c-8.6-10.3 3.8-24.9 15.4-18l80 48c7.8 4.7 7.8 15.9 0 20.6zM362.4 288c8.2 0 14.5 7 13.5 15-7.5 59.2-58.9 105-121.1 105h-13.6c-62.2 0-113.6-45.8-121.1-105-1-8 5.3-15 13.5-15h228.8z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/laugh-squint.js
// module id = 1788
// module chunks = 0